import { render, staticRenderFns } from "./RslEvCpuidTime.vue?vue&type=template&id=3c23a6a0&scoped=true&"
import script from "./RslEvCpuidTime.vue?vue&type=script&lang=js&"
export * from "./RslEvCpuidTime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c23a6a0",
  null
  
)

export default component.exports